module.exports = __webpack_public_path__ + "static/media/info-card-bg.d680a351.svg";